import type { ReactElement } from 'react';
import MenuItem from 'models/MenuItem';
import { toCurrency } from '../../../utils/numbers';

type Props = {
  item: MenuItem
  price: number
  isPremiumItem?: boolean;
};

function RecipePrice({
  item,
  price,
  isPremiumItem = false,
}: Props): ReactElement {
  const { sku } = item;
  const {
    spec,
    sales_price: salesPrice,
    servings,
    subscription_price_per_serving: subscriptionPricePerServing,
    product_type: productType,
  } = sku;
  const orderHistoryText = price ? `${toCurrency(price)}` : `${toCurrency(subscriptionPricePerServing)}`;
  const isLTO = sku.is_lto_box;

  const servingText = servings ? (
    <>
      <span style={{
        ...(isPremiumItem
          ? {
            color: '#31544E',
            fontWeight: 700,
          }
          : {}),
      }}
      >
        {toCurrency(subscriptionPricePerServing)}
      </span>
      {(productType !== 'grocery' && productType !== 'bundle') && (<span> / serving</span>)}
    </>
  ) : orderHistoryText;

  return (
    <>
      <span className="c-recipe__price">
        {(sku.meal_type === 'snack' && item.isOnSale) ? (
          <>
            <span className="c-recipe__discounted_price">
              {toCurrency(parseFloat(item.price) / item.quantity)}
            </span>
            {' '}
            <span className="c-recipe__strikethrough_price">
              {toCurrency(subscriptionPricePerServing)}
            </span>
          </>
        ) : (
          <>
            {servingText}
          </>
        )}
      </span>
      {!!spec && !isLTO && servings !== undefined && (servings <= 1) && productType !== 'ready_to_eat' && (
        <>
          {' / '}
          <span className="c-recipe__spec">
            {spec}
          </span>
        </>
      )}
    </>
  );
}

export default RecipePrice;
